<template>
  <div class="bg-dark px-6 py-5"
    style="min-height: 100%">
      <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <div class="h-full">
      <div
        class="
          container
          mx-auto
          relative
          bg-white
          w-full
          flex flex-col
          item-center
          rounded
        "
        style="min-height: 83vh"
      >
        <div
          class="ml-auto pr-4 mt-3 mb-4 cursor-pointer"
          @click="cancelUpload"
          v-if="vid && $route.params.id"
        >
          <cross-icon />
        </div>
        <ChunkUploadNew
          v-if="isLoaded"
          :key="chunkUploadComponentKey"
          :storage-folder="selectedStorageFolder"
          :storage-id="selectedStorageId"
          :encoder-id="selectedEncoderId"
          :storage="storage"
          :youtubeAccounts="youtubeAccounts"
          :is-paid="isPaid"
          :max-size="maxSize"
          :video-details="this.vid"
          :headers="chunkuploadHeaders"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
          :class="{ 'pt-10': !$route.params.id }"
        />
        <!-- <ChunkUploadUnpaidUser
          v-else-if="isLoaded && !$store.getters.canUseStorage"
          :key="chunkUploadComponentKey"
          :storage-folder="selectedStorageFolder"
          :storage-id="selectedStorageId"
          :encoder-id="selectedEncoderId"
          :storage="storageAccounts[0]"
          :is-paid="false"
          :max-size="maxSize"
          :video-details="this.vid"
          :headers="chunkuploadHeaders"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
          :class="{ 'pt-10': !$route.params.id }"
        /> -->
      </div>
    </div>
    <portal to="headerContent">
      <div class="flex">
        <gd-button class="mr-4 exitBtn" @click="exitUpload">
          {{ $t('frontend_exit') }}
        </gd-button>
      </div>
    </portal>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import Loading from 'vue-loading-overlay';
import {
  required,
  minLength,
  maxLength,
  numeric,
  minValue,
  a,
} from 'vuelidate/lib/validators';
import Video from '@/models/Video';
import 'vue-loading-overlay/dist/vue-loading.css';
import themeConfig from '@/theme/themeConfig.js';
import Auth from '@groovepages/gd-lib/auth';
import store from '@/state';
import axios from 'axios';
import router from '@/router';
import Storage from '@/models/Storage';
import Encoder from '@/models/Encoder';
import YoutubeApiSettings from '@/models/YoutubeApiSettings.js';
import CrossIcon from '@/assets/images/icons/cross_icon.svg';
import limitHelper from '@/mixins/limitHelper.js';

import ChunkUploadNew from '../../components/ChunkUploadNew.vue';
import ChunkUploadUnpaidUser from '../../components/ChunkUploadUnpaidUser.vue';

export default {
  middleware: 'auth',
  layout: 'defaultScrollWithoutSidebarLogo',
  mixins: [limitHelper],
  metaInfo() {
    return { title: 'Video Configuration' };
  },
  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      maxSize: 5000,
      loaderColor: themeConfig.appPrimaryColor,
      chunkUploadComponentKey: 0,
      chunkuploadHeaders: {
        Authorization: `Bearer ${Auth.authenticatedUser().token}`,
        'Cache-Control': null,
        'X-Requested-With': null,
      },
      isLoaded: 0,
      selectedStorageId: 0,
      selectedEncoderId: 0,
      storage: [],
      youtubeAccounts: [],
      selectedStorageFolder: 0,
      storageAccounts: null,
      encodingAccounts: null,
      vid: null,
      localUpload: false,
      allowedUsers: [
        '5f0d5d4a6ca1bd0016c5142f'
      ],
      maxAllowedFiles: 0,
    };
  },
  validations: {},
  computed: {
    showUploadButton() {
      if (!this.$store.getters.canUseStorage) {
        if (
          this.selectedStorageId > 0 &&
          this.selectedEncoderId > 0 &&
          this.selectedStorageFolder &&
          this.selectedStorageFolder != 0 &&
          this.selectedStorageFolder != '0' &&
          this.selectedStorageFolder != ''
        ) {
          return true;
        }
        return false;
      }
      return true;
    },
    isPaid() {
      return this.$store.getters.canUseStorage !== 0;
    }
  },

  async created() {
    this.showLoader();
    const videoId = this.$route.params.id;
    this.user = this.$store.state.user.id;
    this.localUpload = this.allowedUsers.includes(this.user);

    if (videoId) {
      this.$wait.start('videos');
      this.vid = await Video.$find(videoId);

      this.selectedStorageId = this.vid.storage_id;
      this.selectedStorageFolder = this.vid.folder;
      this.selectedEncoderId = this.vid.encoder_id;
    } else if (this.$store.getters.maxVideos != -1) {
      // Get allowed number of videos
      this.maxAllowedFiles = await this.getMaxAllowedVideos();

      if (this.maxAllowedFiles <= 0) {
        this.hideLoader();
        return this.limitReachedError();
      }
    }

    // if (!this.$store.getters.canUseStorage) {
      await this.getStorageAndEncoderDetails();
    // } 
    const remainingSizeData = await axios.get('remaining');
    const remaining = remainingSizeData.data.data.res;

    if (remaining < 5000000000) {
      this.maxSize = Math.floor(remaining / 1000000);
    }
    

    this.isLoaded = 1;

    this.hideLoader();
  },
  components: {
    Loading,
    ChunkUploadNew,
    ChunkUploadUnpaidUser,
    CrossIcon,
  },
  methods: {
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    handleTabChange(newTab) {
      this.currentTab = newTab;
    },
    exitUpload() {
      router.push({ name: 'videos' });
    },
    cancelUpload() {
      const videoId = this.$route.params.id;
      this.$router.push({
        name: 'AddNewVideo',
        params: { id: videoId },
      });
    },
    async limitReachedError() {
      const { value: accept } = await Swal.fire({
        title: this.$t('frontend_groovevideo_account_limit_reached'),
        type: 'error',
        text: this.$t('frontend_groovevideo_cannot_add_video'),
        allowOutsideClick: false,
      });

      if(accept) {
        this.$router.push({ name: 'videos' });
      }
      return false;
    },
    async getStorageAndEncoderDetails(){
      this.storageAccounts = await Storage.$get();
      this.encodingAccounts = await Encoder.$get();
      this.youtubeAccounts = await YoutubeApiSettings.$get();

      this.selectedStorageId =
        typeof this.storageAccounts[0] !== 'undefined' &&
        typeof this.storageAccounts[0].id !== 'undefined'
          ? this.storageAccounts[0].id
          : 0;

      this.selectedEncoderId =
        typeof this.encodingAccounts[0] !== 'undefined' &&
        typeof this.encodingAccounts[0].id !== 'undefined'
          ? this.encodingAccounts[0].id
          : 0;

      const storageFolder = this.$store.state.user.id;
      this.selectedStorageFolder = storageFolder && storageFolder !== '0' && storageFolder !== '' ? storageFolder : 0;
      this.storage = this.storageAccounts && this.storageAccounts[0] ? this.storageAccounts[0] : [];
    }
  },
};
</script>

<style lang="scss">
.uploadArea {
  background-color: #191d3a;
}

.exitBtn {
  color: #191d3a !important;
  border-color: #d5d8e5 !important;
}

.dropzone-custom-title {
  font-size: 20px !important;
  color: #191d3a;
}

.uploadTab {
  border-bottom: 1px solid #d5d8e5;
  margin-top: 10px;
  width: 100%;
  max-width: 700px;
  .gs-default-tabs-item {
    color: #989ab2;
    &.tabs__item_active {
      color: #fd6481;
    }
  }
  button.tabs__item {
    display: inline-block;
    // padding-bottom: 5px;
    padding: 0 20px 5px 20px!important;
    &:focus,
    &:active {
      outline: none;
    }
  }
}
</style>
